import { useTranslator } from "@eo-locale/react";

import { SyntheticEvent, useState } from "react";

import { useRouter } from "next/router";

import trim from "lodash/trim";

import isEmpty from "lodash/isEmpty";

import { TemplateModal, useBreakpointValue } from "@/storybook-components";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { setError, setAnswer } from "@/redux/features/questions/slice";
import { createUnverifiedUser } from "@/redux/features/user/thunk";
import UnverifiedForm from "./form";
import {
  setModalStatus,
  setTriggerPoint
} from "@/redux/features/unverified-modal/slice";
import { defaultTriggerPoint } from "@/components/tools/brainstormer/content";

const UnverifiedUserModal = ({ isOpen, onClose, modalHeader }): JSX.Element => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { query } = useRouter();

  const { answers, errors } = useAppSelector((state) => state.questions);

  const [hasErrorInSubmission, setHasErrorInSubmission] = useState(false);

  const isMobileScreen = useBreakpointValue({
    base: true,
    md: false
  });

  const cancelPost = async () => {
    onClose();
    dispatch(setModalStatus("cancel"));
    dispatch(setTriggerPoint(defaultTriggerPoint));
    setHasErrorInSubmission(false);
    await dispatch(
      setAnswer({
        questionId: "email",
        answer: ""
      })
    );
    await dispatch(
      setAnswer({
        questionId: "login",
        answer: ""
      })
    );
    await dispatch(
      setAnswer({
        questionId: "tosQuestion",
        answer: false
      })
    );
  };

  const validateAndDispatchError = async (field, errorType = "blank") => {
    if (!answers?.[field]) {
      await dispatch(setError({ questionId: field, error: [errorType] }));
    }
  };
  const onSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();
    dispatch(setModalStatus("submit"));
    let errorCount = 0;
    if (!answers?.email) {
      await validateAndDispatchError("email");
      errorCount += 1;
    }
    if (!answers?.login) {
      await validateAndDispatchError("login");
      errorCount += 1;
    }
    if (isEmpty(trim(answers?.login))) {
      await validateAndDispatchError("login");
      errorCount += 1;
    }
    if (!answers?.tosQuestion) {
      await validateAndDispatchError("tosQuestion", "accepted");
      errorCount += 1;
    }
    if (errors?.email) errorCount += 1;

    if (errorCount <= 0) {
      await dispatch(
        createUnverifiedUser({ projectId: query.projectId as string })
      );
    }

    if (errorCount > 0) {
      setHasErrorInSubmission(true);
      return false;
    }
    await setHasErrorInSubmission(false);

    ["email", "login", "tosQuestion"].forEach(async (question) => {
      await dispatch(
        setAnswer({
          questionId: question,
          answer: answers?.[question]
        })
      );
    });
    onClose();
  };

  return (
    <TemplateModal
      header={modalHeader}
      body={
        <UnverifiedForm
          isAsterixRequired={false}
          hasErrorInSubmission={hasErrorInSubmission}
        />
      }
      isOpen={isOpen}
      onClose={cancelPost}
      buttonPrimary={translate("common.continue")}
      buttonSecondary={translate("common.cancel")}
      buttonPrimaryVariant="primary"
      isPrimaryDestructive={false}
      buttonSecondaryVariant="secondary"
      isFullSizedModal={isMobileScreen}
      onPrimaryClickHandler={onSubmit}
      onSecondaryClickHandler={cancelPost}
    />
  );
};

export default UnverifiedUserModal;
